/*
 * Dreamy — pop-up de bienvenue (section dreamy-newsletter-popup, groupe pied de page).
 * Apparaît une fois, après N secondes de navigation cumulées sur le site (toutes pages, onglet visible),
 * jamais par-dessus une autre fenêtre ni le bandeau cookies. « Non merci » : pause de N jours ;
 * inscription : plus jamais. L'inscription envoie normalement le formulaire client Shopify (protection anti-spam
 * hCaptcha comprise) ; au retour (?customer_posted=true), la pop-up se rouvre sur le code, appliqué au panier
 * (/discount/CODE).
 */
if (!customElements.get('dreamy-popup')) {
  customElements.define(
    'dreamy-popup',
    class DreamyPopup extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.form = this.querySelector('[data-popup-form]');
        if (!this.dialog || !this.form) return;
        this.key = 'dreamy_popup';
        this.D = window.Dreamy || {};

        this.addEventListener('click', (e) => {
          if (e.target.closest('[data-popup-close]')) this.close();
          var copy = e.target.closest('[data-popup-copy]');
          if (copy) this.copy(copy);
        });
        // Clic sur le voile : fermer.
        this.dialog.addEventListener('click', (e) => {
          if (e.target === this.dialog) this.close();
        });
        this.dialog.addEventListener('cancel', () => this.remember('pause'));
        this.form.addEventListener('submit', (e) => this.submit(e));

        // Éditeur de thème : ouverte à la sélection de la section, sans mémoriser quoi que ce soit.
        if (this.hasAttribute('data-design-mode')) {
          document.addEventListener('shopify:section:select', (e) => {
            if (this.closest('.shopify-section') && e.target === this.closest('.shopify-section')) this.open(true);
          });
          document.addEventListener('shopify:section:deselect', () => this.dialog.open && this.dialog.close());
          return;
        }

        // Retour d'une inscription envoyée normalement (vérification anti-robot) : afficher le code.
        if (/[?&]customer_posted=true/.test(location.search) && this.read('pending')) {
          this.store('pending', null);
          this.cleanUrl();
          this.success();
          this.open(true);
          return;
        }
        // Retour avec une erreur renvoyée par Shopify (form.errors) : rouvrir sur le formulaire et son message.
        var serverError = this.form.querySelector('[data-popup-error]');
        if (this.read('pending') && serverError && serverError.textContent.trim()) {
          this.store('pending', null);
          this.open(true);
          return;
        }
        if (!this.allowed()) return;
        this.arm();
      }

      // Retire ?customer_posted=true#DreamyPopupForm de la barre d'adresse.
      cleanUrl() {
        try {
          var url = new URL(location.href);
          url.searchParams.delete('customer_posted');
          url.hash = '';
          history.replaceState(history.state, '', url.pathname + url.search);
        } catch (e) {}
      }

      // Mémoire (localStorage) : done = inscrit ; until = pause jusqu'à cette date ; pending = envoi en cours.
      read(name) {
        try {
          return JSON.parse(localStorage.getItem(this.key) || '{}')[name];
        } catch (e) {
          return null;
        }
      }
      store(name, value) {
        try {
          var data = JSON.parse(localStorage.getItem(this.key) || '{}');
          if (value === null) delete data[name];
          else data[name] = value;
          localStorage.setItem(this.key, JSON.stringify(data));
        } catch (e) {}
      }
      allowed() {
        if (this.read('done')) return false;
        var until = this.read('until');
        if (until && Date.now() < until) return false;
        try {
          if (sessionStorage.getItem('dreamy_popup_seen')) return false;
        } catch (e) {}
        return true;
      }
      remember(kind) {
        if (kind === 'done') this.store('done', true);
        else if (!this.read('done')) this.store('until', Date.now() + (Number(this.dataset.pauseDays) || 14) * 864e5);
      }

      // Temps de navigation cumulé sur le site (toutes pages de la visite, onglet visible seulement),
      // gardé en sessionStorage : la pop-up s'ouvre quand il atteint le délai réglé.
      arm() {
        var delay = Number(this.dataset.delay) || 12000;
        var spent = 0;
        try {
          spent = Number(sessionStorage.getItem('dreamy_popup_time')) || 0;
        } catch (e) {}
        var last = Date.now();
        var save = () => {
          if (document.visibilityState === 'visible') spent += Date.now() - last;
          last = Date.now();
          try {
            sessionStorage.setItem('dreamy_popup_time', String(spent));
          } catch (e) {}
        };
        var tick = setInterval(() => {
          save();
          if (spent >= delay) {
            clearInterval(tick);
            this.open(false);
          }
        }, 1000);
        document.addEventListener('visibilitychange', save);
        window.addEventListener('pagehide', save);
      }

      busy() {
        if (document.querySelector('dialog[open]')) return true;
        var banner = document.getElementById('shopify-pc__banner');
        return !!(banner && banner.offsetParent !== null);
      }

      open(force) {
        if (!force && this.busy()) {
          setTimeout(() => this.open(false), 3000);
          return;
        }
        try {
          sessionStorage.setItem('dreamy_popup_seen', '1');
        } catch (e) {}
        if (this.D.openDialog) this.D.openDialog(this.dialog);
        else this.dialog.showModal();
        if (this.D.track) this.D.track('dreamy_popup_view', {});
      }

      close() {
        if (this.hasAttribute('data-design-mode')) return this.dialog.close();
        this.remember(this.read('done') ? 'done' : 'pause');
        if (this.D.closeDialog) this.D.closeDialog(this.dialog);
        else this.dialog.close();
      }

      error(msg, field) {
        var el = this.form.querySelector('[data-popup-error]');
        if (el) el.textContent = msg || '';
        if (field) field.focus();
      }

      // Envoi normal du formulaire (pas d'envoi en arrière-plan) : la protection anti-spam de Shopify (hCaptcha)
      // doit pouvoir ajouter son jeton au moment de l'envoi, sinon « Missing CAPTCHA token ». On ne bloque l'envoi
      // que si l'e-mail est invalide ; au retour (?customer_posted=true), la pop-up se rouvre sur le code.
      submit(e) {
        var email = this.form.querySelector('input[type="email"]');
        if (!email.value || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value)) {
          e.preventDefault();
          return this.error(this.dataset.errorEmail, email);
        }
        this.error('');
        if (this.hasAttribute('data-design-mode')) {
          e.preventDefault();
          return this.success();
        }
        this.store('pending', true);
        // Si hCaptcha affiche une vérification visuelle, elle doit passer au-dessus : la fenêtre quitte le
        // premier plan (modale → simple) pendant l'envoi, sans disparaître.
        if (this.dialog.open && typeof this.dialog.show === 'function') {
          this.dialog.close();
          this.dialog.show();
        }
        var button = this.form.querySelector('[data-popup-submit]');
        var spinner = button && button.querySelector('.loading__spinner');
        if (button) button.setAttribute('aria-busy', 'true');
        if (spinner) spinner.classList.remove('hidden');
      }

      success() {
        this.remember('done');
        this.querySelector('[data-popup-step="form"]').hidden = true;
        var done = this.querySelector('[data-popup-step="done"]');
        done.hidden = false;
        if (this.D.track) this.D.track('dreamy_popup_signup', {});
        var code = this.dataset.code;
        if (!code || this.hasAttribute('data-design-mode')) return;
        // Applique le code au panier (cookie Shopify) ; le client le voit au paiement.
        fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
          .then((res) => {
            if (res.ok) {
              var applied = this.querySelector('[data-popup-applied]');
              if (applied) applied.hidden = false;
            }
          })
          .catch(function () {});
      }

      copy(button) {
        var code = this.dataset.code;
        var label = button.textContent;
        var done = () => {
          button.textContent = button.dataset.copied || label;
          setTimeout(() => (button.textContent = label), 2000);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, done);
        else done();
      }
    }
  );
}
